export default __webpack_public_path__ + "images/models/4ae5478e6766da5f858adc88b4aff474.usdz";